export enum EOrderCreation {
  search = 'orderCreation/search',
  getMatchedCardById = 'orderCreation/getMatchedCardById',
  requestOrder = 'orderCreation/requestOrder',
}
